export default __webpack_public_path__ + "static/media/275.41bca7a0.gif";